export const data = {


    scene: '03_tupen_vaihto',
    kysymysteksti: 'Onneksi sinulla on aina mukana varalla kyynärsauvan kumituppi. Vaihdat kuluneen ja haljenneen kumitupen uuteen.',

    optiot: []


};